var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "deateails-page" } },
    [
      _c("progressbar", { attrs: { progressbar: _vm.data.progressbar } }),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-1" }),
        _c(
          "div",
          { staticClass: "col-lg-10" },
          [
            _c("h1", { staticClass: "mb-4" }, [
              _vm._v(_vm._s(_vm.trans("details_h1")))
            ]),
            _c("div", { staticClass: "baumit-table-container mb-4" }, [
              _c(
                "div",
                {
                  staticClass: "d-flex justify-content-start align-items-center"
                },
                [
                  _c("h3", { staticClass: "mb-0 mr-auto" }, [
                    _vm._v(
                      _vm._s(_vm.isExistDisplay(_vm.selectedName)) +
                        " | " +
                        _vm._s(
                          _vm.isExistDisplay(_vm.calculatorDefaulSystem.name)
                        )
                    )
                  ]),
                  _c(
                    "a",
                    {
                      staticClass:
                        "button type-20 small transparent show-compact mr-2",
                      class: _vm.view_compact,
                      on: {
                        click: function($event) {
                          return _vm.onChangeTableView("close")
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("view_compact")
                      ])
                    ]
                  ),
                  _c(
                    "a",
                    {
                      staticClass:
                        "button type-20 small transparent show-comfy",
                      class: _vm.view_comfy,
                      on: {
                        click: function($event) {
                          return _vm.onChangeTableView("open")
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("view_comfy")
                      ])
                    ]
                  )
                ]
              )
            ]),
            _c(
              "div",
              {
                staticClass:
                  "calculation-data white-background box-shadow mb-4",
                class: { opened: _vm.isCalculationDataOpen },
                attrs: { id: "calculationData" }
              },
              [
                _c("div", { staticClass: "accordion position-relative" }, [
                  !_vm.isLoadedYourData || !_vm.isLoadedDetails
                    ? _c(
                        "div",
                        { staticClass: "loader-full-screen" },
                        [_c("loader")],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      staticClass:
                        "accordion-header p-3 d-flex justify-content-start position-relative",
                      on: {
                        click: function($event) {
                          return _vm.onChangeCalculationDataOpenClose()
                        }
                      }
                    },
                    [
                      _c("h3", { staticClass: "mb-0 mt-2" }, [
                        _vm._v(_vm._s(_vm.data.yourData.title))
                      ]),
                      _c("div", { staticClass: "icons ml-auto" }, [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v(_vm._s(_vm.calculationDataIcon))
                        ])
                      ])
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "accordion-body pl-4 pb-4 pr-4 pt-1" },
                    [
                      _vm._l(_vm.data.yourData.rows, function(row, index) {
                        return _c("div", { staticClass: "row mb-4" }, [
                          row.title != ""
                            ? _c(
                                "div",
                                { class: [_vm.getTitleClass(row.title)] },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex justify-content-start align-items-center h-100"
                                    },
                                    [
                                      _c("p", { staticClass: "bodytext m-0" }, [
                                        _c("b", [_vm._v(_vm._s(row.title))])
                                      ])
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "div",
                            { class: [_vm.getDateClass(row.title)] },
                            _vm._l(row.items, function(input, i) {
                              return _c(
                                "div",
                                { staticClass: "col-lg-4 col-md-6 col-12" },
                                [
                                  _c(
                                    "div",
                                    {
                                      class: [
                                        i == 0 ? "row pr-5 r-pr-5-mobile" : "",
                                        i == 1
                                          ? "row pr-3 pl-3 r-pr-3-mobile r-pl-3-mobile"
                                          : "",
                                        i == 2
                                          ? "row pl-5 r-pl-5-mobile pr-0"
                                          : "",
                                        i == 3
                                          ? "row pr-5 r-pr-5-mobile mt-4"
                                          : ""
                                      ]
                                    },
                                    [
                                      _c("div", { staticClass: "col-7" }, [
                                        _c(
                                          "p",
                                          { staticClass: "bodytext m-0 mt-2" },
                                          [_vm._v(_vm._s(input.title))]
                                        )
                                      ]),
                                      _c(
                                        "div",
                                        { class: [i == 2 ? "col-5" : "col-4"] },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "form-group w-100 m-0"
                                            },
                                            [
                                              input.type == "text"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "calculationUnit unit"
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value: input.value,
                                                            expression:
                                                              "input.value"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "calculationDataInput",
                                                        attrs: {
                                                          type: "text",
                                                          id: input.id
                                                        },
                                                        domProps: {
                                                          value: input.value
                                                        },
                                                        on: {
                                                          blur: function(
                                                            $event
                                                          ) {},
                                                          input: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            ) {
                                                              return
                                                            }
                                                            _vm.$set(
                                                              input,
                                                              "value",
                                                              $event.target
                                                                .value
                                                            )
                                                          }
                                                        }
                                                      }),
                                                      _c("div", {
                                                        staticClass: "unit",
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            _vm.getUnit(
                                                              input.unit
                                                            )
                                                          )
                                                        }
                                                      })
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          ),
                                          input.type == "select"
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "form-group w-100 m-0 min-120"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "dropdown variants w-100"
                                                    },
                                                    [
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "btn btn-secondary dropdown-toggle ",
                                                          attrs: {
                                                            type: "button",
                                                            id: "dropdownMenu2",
                                                            "data-toggle":
                                                              "dropdown",
                                                            "aria-haspopup":
                                                              "true",
                                                            "aria-expanded":
                                                              "false"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              input.selectedValue
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "dropdown-menu",
                                                          attrs: {
                                                            "aria-labelledby":
                                                              "dropdownMenu2",
                                                            "x-placement":
                                                              "bottom-start"
                                                          }
                                                        },
                                                        _vm._l(
                                                          input.items,
                                                          function(
                                                            item,
                                                            chilIndex
                                                          ) {
                                                            return _c(
                                                              "button",
                                                              {
                                                                key: chilIndex,
                                                                staticClass:
                                                                  "dropdown-item",
                                                                attrs: {
                                                                  type: "button"
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    input.selectedValue = item
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(item)
                                                                )
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          input.type == "colorpicker"
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "form-group w-100 m-0"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "calculationUnit",
                                                      attrs: {
                                                        id:
                                                          "calculationDataFootingColor"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                    " +
                                                          _vm._s(
                                                            _vm.log(
                                                              "default color" +
                                                                input.selectedColor
                                                            )
                                                          ) +
                                                          "\n                                                    "
                                                      ),
                                                      _c(
                                                        "details-color-picker",
                                                        {
                                                          attrs: {
                                                            colors: input.items,
                                                            inputId: input.id,
                                                            defaultValue:
                                                              input.selectedColor,
                                                            typheadClass:
                                                              "color-picker" +
                                                              input.id
                                                          },
                                                          on: {
                                                            selectedColor:
                                                              _vm.onSelectedColor
                                                          }
                                                        }
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        ])
                      }),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-start align-items-center"
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "button type-2 ml-auto mt-4 calculator-modify-button",
                              attrs: { id: "modify" },
                              on: {
                                click: function($event) {
                                  return _vm.updateDetails(true)
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.trans("button_modify")) +
                                  "\n                            "
                              )
                            ]
                          )
                        ]
                      )
                    ],
                    2
                  )
                ])
              ]
            ),
            _vm._l(_vm.data.sections, function(section) {
              return section.items.length != 0
                ? _c("div", { staticClass: "baumit-table-container mb-4" }, [
                    _c("h4", { staticClass: "table-style m-0" }, [
                      _vm._v(_vm._s(section.name))
                    ]),
                    _c(
                      "div",
                      { staticClass: "table-responsive position-relative" },
                      [
                        _c(
                          "table",
                          {
                            staticClass: "baumit-table table m-0",
                            class: _vm.tableView
                          },
                          [
                            _c("thead", [
                              _c("tr", [
                                _c(
                                  "th",
                                  {
                                    staticClass: "big-padding",
                                    attrs: { scope: "col" }
                                  },
                                  [
                                    _c("p", { staticClass: "bodytext m-0" }, [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.trans("details_product_type")
                                          )
                                        )
                                      ])
                                    ])
                                  ]
                                ),
                                _c(
                                  "th",
                                  {
                                    staticClass: "big-padding",
                                    attrs: { scope: "col" }
                                  },
                                  [
                                    _c("p", { staticClass: "bodytext m-0" }, [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.trans("details_baumit_product")
                                          )
                                        )
                                      ])
                                    ])
                                  ]
                                ),
                                _c(
                                  "th",
                                  {
                                    staticClass: "big-padding",
                                    attrs: { scope: "col" }
                                  },
                                  [
                                    _c("p", { staticClass: "bodytext m-0" }, [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(_vm.trans("details_area"))
                                        )
                                      ])
                                    ])
                                  ]
                                ),
                                _c(
                                  "th",
                                  {
                                    staticClass: "big-padding hidden",
                                    attrs: { scope: "col" }
                                  },
                                  [
                                    _c("p", { staticClass: "bodytext m-0" }, [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.trans("details_consumption")
                                          )
                                        )
                                      ])
                                    ])
                                  ]
                                ),
                                _c(
                                  "th",
                                  {
                                    staticClass: "big-padding hidden",
                                    attrs: { scope: "col" }
                                  },
                                  [
                                    _c("p", { staticClass: "bodytext m-0" }, [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(_vm.trans("details_packing"))
                                        )
                                      ])
                                    ])
                                  ]
                                ),
                                _c(
                                  "th",
                                  {
                                    staticClass: "big-padding hidden",
                                    attrs: { scope: "col" }
                                  },
                                  [
                                    _c("p", { staticClass: "bodytext m-0" }, [
                                      _c("b", [
                                        _vm._v(_vm._s(_vm.trans("details_qty")))
                                      ])
                                    ])
                                  ]
                                ),
                                _vm.isShowPrices
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "big-padding",
                                        attrs: { scope: "col" }
                                      },
                                      [
                                        _c(
                                          "p",
                                          { staticClass: "bodytext m-0" },
                                          [
                                            _c("b", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.trans("details_price")
                                                ) + " m"
                                              ),
                                              _c("sup", [_vm._v("2")])
                                            ])
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.isShowPrices
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "big-padding",
                                        attrs: { scope: "col" }
                                      },
                                      [
                                        _c(
                                          "p",
                                          { staticClass: "bodytext m-0" },
                                          [
                                            _c("b", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.trans(
                                                    "details_total_price"
                                                  )
                                                )
                                              )
                                            ])
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            ]),
                            _c(
                              "tbody",
                              [
                                _vm._l(section.items, function(
                                  item,
                                  indexItems
                                ) {
                                  return _c(
                                    "tr",
                                    { staticClass: "calculator-data-row" },
                                    [
                                      _c("td", { attrs: { scope: "row" } }, [
                                        _vm.isExist(item.products[0]) &&
                                        _vm.isExist(
                                          item.products[0].product_type
                                        ) &&
                                        _vm.isExist(
                                          item.products[0].product_type.name
                                        )
                                          ? _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "bodytext m-0 calculator-product-type-name"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.isExistDisplay(
                                                      item.products[0]
                                                        .product_type.name
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]),
                                      _c("td", [
                                        item.products.length > 1 ||
                                        (_vm.isExist(
                                          item.products[0].variants
                                        ) &&
                                          item.products[0].variants.length > 1)
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "form-group w-100 m-0"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "dropdownCalculator"
                                                  },
                                                  [
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "btn btn-secondary dropdown-toggle-dropdownCalculator",
                                                        attrs: {
                                                          type: "button",
                                                          id:
                                                            item.products[0]
                                                              .product_type.id,
                                                          "data-toggle":
                                                            "dropdown",
                                                          "aria-haspopup":
                                                            "true",
                                                          "aria-expanded":
                                                            "false"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                            " +
                                                            _vm._s(
                                                              item
                                                                .selectedProduct
                                                                .name +
                                                                ", " +
                                                                item
                                                                  .selectedVariant
                                                                  .name
                                                            ) +
                                                            "\n                                        "
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "dropdown-menu",
                                                        attrs: {
                                                          "aria-labelledby":
                                                            item.products[0]
                                                              .product_type.id
                                                        }
                                                      },
                                                      [
                                                        item.products[0]
                                                          .product_type
                                                          .optional == 1
                                                          ? _c(
                                                              "button",
                                                              {
                                                                staticClass:
                                                                  "dropdown-item",
                                                                attrs: {
                                                                  type: "button"
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.selectProductOption(
                                                                      item
                                                                        .products[0]
                                                                        .product_type
                                                                        .id,
                                                                      -1,
                                                                      -1,
                                                                      item.area
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                                " +
                                                                    _vm._s(
                                                                      _vm.trans(
                                                                        "no_calculation"
                                                                      )
                                                                    ) +
                                                                    "\n                                            "
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._l(
                                                          item.products,
                                                          function(
                                                            product,
                                                            indexProducts
                                                          ) {
                                                            return _vm._l(
                                                              product.variants,
                                                              function(
                                                                variant,
                                                                indexVariants
                                                              ) {
                                                                return _c(
                                                                  "button",
                                                                  {
                                                                    key:
                                                                      indexProducts +
                                                                      "" +
                                                                      indexVariants,
                                                                    staticClass:
                                                                      "dropdown-item",
                                                                    attrs: {
                                                                      type:
                                                                        "button"
                                                                    },
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.selectProductOption(
                                                                          product
                                                                            .product_type
                                                                            .id,
                                                                          product
                                                                            .product
                                                                            .id,
                                                                          variant.id,
                                                                          item.area
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                                                    " +
                                                                        _vm._s(
                                                                          product
                                                                            .product
                                                                            .name +
                                                                            ", " +
                                                                            variant.name
                                                                        ) +
                                                                        "\n                                                "
                                                                    )
                                                                  ]
                                                                )
                                                              }
                                                            )
                                                          }
                                                        )
                                                      ],
                                                      2
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "form-group w-100 m-0"
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "bodytext calculator-product-name m-0"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.selectedProduct
                                                          .name +
                                                          ", " +
                                                          item.selectedVariant
                                                            .name
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                      ]),
                                      _c("td", [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex justify-content-center"
                                          },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: item.area,
                                                  expression: "item.area"
                                                }
                                              ],
                                              staticClass:
                                                "form-control small facadeInput",
                                              attrs: { type: "text" },
                                              domProps: { value: item.area },
                                              on: {
                                                change: function($event) {
                                                  return _vm.selectProductOption(
                                                    item.products[0]
                                                      .product_type.id,
                                                    item.selectedProduct.id,
                                                    item.selectedVariant.id,
                                                    $event.target.value
                                                  )
                                                },
                                                keyup: function($event) {
                                                  return _vm.selectProductOptionWhiteTimer(
                                                    item.products[0]
                                                      .product_type.id,
                                                    item.selectedProduct.id,
                                                    item.selectedVariant.id,
                                                    $event.target.value
                                                  )
                                                },
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.$set(
                                                    item,
                                                    "area",
                                                    $event.target.value
                                                  )
                                                }
                                              }
                                            }),
                                            _vm._m(0, true)
                                          ]
                                        )
                                      ]),
                                      _c("td", { staticClass: "hidden" }, [
                                        _c(
                                          "p",
                                          { staticClass: "bodytext m-0" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("currency")(
                                                  item.consumption,
                                                  "",
                                                  "",
                                                  2,
                                                  ".",
                                                  "",
                                                  false
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]),
                                      _c("td", { staticClass: "hidden" }, [
                                        _c(
                                          "p",
                                          { staticClass: "bodytext m-0" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                item.selectedVariant.attributes
                                                  .packaging_size_value
                                              )
                                            )
                                          ]
                                        )
                                      ]),
                                      _c("td", { staticClass: "hidden" }, [
                                        _c(
                                          "p",
                                          { staticClass: "bodytext m-0" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("currency")(
                                                  item.qty,
                                                  "",
                                                  "",
                                                  2,
                                                  ".",
                                                  "",
                                                  false
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm.isShowPrices
                                        ? _c("td", [
                                            _c(
                                              "p",
                                              { staticClass: "bodytext m-0" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("currency")(
                                                      item.pricem2,
                                                      "",
                                                      ".",
                                                      2,
                                                      ",",
                                                      "",
                                                      false
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm.isShowPrices
                                        ? _c("td", [
                                            _c(
                                              "p",
                                              { staticClass: "bodytext m-0" },
                                              [
                                                _vm._v(
                                                  "\n                                    " +
                                                    _vm._s(
                                                      _vm._f("currency")(
                                                        item.price,
                                                        "",
                                                        ".",
                                                        2,
                                                        ",",
                                                        "",
                                                        false
                                                      )
                                                    )
                                                )
                                              ]
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  )
                                }),
                                _vm.isShowPrices
                                  ? _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticClass:
                                            "big-padding colspan-this-total-price",
                                          attrs: { colspan: "3" }
                                        },
                                        [
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "bodytext m-0 text-right"
                                            },
                                            [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.trans(
                                                      "details_total_facade_without"
                                                    )
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        ]
                                      ),
                                      _c(
                                        "td",
                                        {
                                          staticClass: "big-padding text-center"
                                        },
                                        [
                                          _c(
                                            "p",
                                            { staticClass: "bodytext m-0" },
                                            [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("currency")(
                                                      section.totalPricem2,
                                                      "",
                                                      ".",
                                                      2,
                                                      ",",
                                                      "",
                                                      false
                                                    )
                                                  ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm.calculatorDefaulSystem
                                                        .extraData.currency
                                                    )
                                                )
                                              ])
                                            ]
                                          )
                                        ]
                                      ),
                                      _c("td", { staticClass: "big-padding" }, [
                                        _c(
                                          "p",
                                          { staticClass: "bodytext m-0" },
                                          [
                                            _c("b", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("currency")(
                                                    section.totalPrice,
                                                    "",
                                                    ".",
                                                    2,
                                                    ",",
                                                    "",
                                                    false
                                                  )
                                                ) +
                                                  " " +
                                                  _vm._s(
                                                    _vm.calculatorDefaulSystem
                                                      .extraData.currency
                                                  )
                                              )
                                            ])
                                          ]
                                        )
                                      ])
                                    ])
                                  : _vm._e()
                              ],
                              2
                            )
                          ]
                        ),
                        !_vm.isLoadedDetails
                          ? _c(
                              "div",
                              { staticClass: "loader-full-screen" },
                              [_c("loader")],
                              1
                            )
                          : _vm._e()
                      ]
                    )
                  ])
                : _vm._e()
            }),
            _vm.isShowPrices
              ? _c(
                  "div",
                  {
                    staticClass:
                      "baumit-table-container table-with-white-body mb-4"
                  },
                  [
                    _c("h4", { staticClass: "table-style m-0" }, [
                      _vm._v(_vm._s(_vm.trans("details_total_price")))
                    ]),
                    _c("div", { staticClass: "table-responsive" }, [
                      _c("table", { staticClass: "baumit-table table m-0" }, [
                        _c("tbody", [
                          _c("tr", [
                            _c(
                              "td",
                              {
                                staticClass: "big-padding",
                                attrs: { scope: "row" }
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "bodytext totoal-price text-right m-0"
                                  },
                                  [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.trans("details_together_without")
                                        )
                                      )
                                    ])
                                  ]
                                )
                              ]
                            ),
                            _c("td", {
                              staticClass: "big-padding text-center"
                            }),
                            _c("td", { staticClass: "big-padding" }, [
                              _c(
                                "p",
                                {
                                  staticClass: "bodytext totoal-price red m-0"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("currency")(
                                        _vm.data.totalPrice,
                                        "",
                                        ".",
                                        2,
                                        ",",
                                        "",
                                        false
                                      )
                                    ) +
                                      " " +
                                      _vm._s(
                                        _vm.calculatorDefaulSystem.extraData
                                          .currency
                                      )
                                  )
                                ]
                              )
                            ])
                          ]),
                          _c("tr", [
                            _c(
                              "td",
                              {
                                staticClass: "big-padding",
                                attrs: { scope: "row" }
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "bodytext totoal-price text-right m-0"
                                  },
                                  [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.trans("details_together_with")
                                        )
                                      )
                                    ])
                                  ]
                                )
                              ]
                            ),
                            _c("td", {
                              staticClass: "big-padding text-center"
                            }),
                            _c("td", { staticClass: "big-padding" }, [
                              _c(
                                "p",
                                {
                                  staticClass: "bodytext totoal-price red m-0"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("currency")(
                                        _vm.data.TotalPriceWithVat,
                                        "",
                                        ".",
                                        2,
                                        ",",
                                        "",
                                        false
                                      )
                                    ) +
                                      " " +
                                      _vm._s(
                                        _vm.calculatorDefaulSystem.extraData
                                          .currency
                                      )
                                  )
                                ]
                              )
                            ])
                          ]),
                          _vm._m(1)
                        ])
                      ])
                    ])
                  ]
                )
              : _vm._e(),
            _c("div", { staticClass: "baumit-table-container" }, [
              _c("div", { staticClass: "table-responsive" }, [
                _c("table", { staticClass: "w-100" }, [
                  _c("tbody", [
                    _c("tr", [
                      _c(
                        "td",
                        {
                          staticClass: "big-padding w-100",
                          attrs: { colspan: "3", width: "100%" }
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "button type-17 red transparent capitalize float-right",
                              on: {
                                click: function($event) {
                                  return _vm.getPDFCall()
                                }
                              }
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("get_app")
                              ]),
                              _vm._v(
                                _vm._s(_vm.trans("details_preview_pdf")) +
                                  "\n                                "
                              )
                            ]
                          )
                        ]
                      )
                    ])
                  ])
                ])
              ])
            ])
          ],
          2
        ),
        _c("div", { staticClass: "col-lg-1" })
      ]),
      _c("div", { staticClass: "row mb-4" }, [
        _c("div", { staticClass: "col-lg-1" }),
        _c("div", { staticClass: "col-lg-10" }, [
          _c(
            "button",
            {
              staticClass: "button type-1 mb-3",
              attrs: { id: "toStep4" },
              on: {
                click: function($event) {
                  return _vm.goToDiscountsWhiteSystem("goToDiscounts")
                }
              }
            },
            [
              _vm._v(
                _vm._s(_vm.trans("button_gettingdiscount")) + "\n            "
              )
            ]
          ),
          _c(
            "div",
            { staticClass: "step row white-background box-shadow get-better" },
            [
              _c("div", { staticClass: "col-lg-1" }),
              _c("div", { staticClass: "col-lg-8" }, [
                _c("h3", { staticClass: "mb-4" }, [
                  _vm._v(_vm._s(_vm.trans("product_selector_getbetter")))
                ]),
                _c("span", { staticClass: "get-better-text" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.trans("product_selector_getbetter_text"))
                  )
                ])
              ]),
              _c("div", { staticClass: "col-lg-3" })
            ]
          ),
          _vm.trans("legal_text") != "{empty}" &&
          _vm.trans("legal_text_title") != "{empty}"
            ? _c(
                "div",
                {
                  staticClass: "step row white-background box-shadow get-better"
                },
                [
                  _c("div", { staticClass: "col-lg-1" }),
                  _c("div", { staticClass: "col-lg-8" }, [
                    _c("h3", { staticClass: "mb-4" }, [
                      _vm._v(_vm._s(_vm.trans("legal_text_title")))
                    ]),
                    _c("span", { staticClass: "get-better-text" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.trans("legal_text"))
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "col-lg-3" })
                ]
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "d-flex justify-content-start align-items-center" },
            [
              _c(
                "button",
                {
                  staticClass: "button type-15 transparent",
                  attrs: { id: "backToStep2" },
                  on: {
                    click: function($event) {
                      return _vm.backToProduct("backToProduct")
                    }
                  }
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("keyboard_backspace")
                  ]),
                  _vm._v(
                    _vm._s(_vm.trans("navigation_back")) + "\n                "
                  )
                ]
              )
            ]
          )
        ]),
        _c("div", { staticClass: "col-lg-1" })
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "bodytext m-0 ml-2" }, [
      _vm._v("m"),
      _c("sup", [_vm._v("2")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "big-padding d-none", attrs: { colspan: "3" } })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }